import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext"; // ✅ aynı context

const pickHB = (userPermissions) => {
  if (!userPermissions) return {};
  return (
    userPermissions["hazir-beton"] ||
    userPermissions["hazir_beton"] ||
    userPermissions["hazirbeton"] ||
    userPermissions["hazirBeton"] ||
    {}
  );
};

const PrivateRoute = ({ children }) => {
  const { user, role, userPermissions, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div style={{ textAlign: "center", marginTop: 40 }}>Yükleniyor...</div>;
  if (!user || !role) return <Navigate to="/giris" replace />;

  const normalizedRole = role?.toLocaleLowerCase("tr-TR");
  const isOwner = normalizedRole === "oluşturucu";
  if (isOwner) return children;

  const hb = pickHB(userPermissions);

  const path = (location.pathname || "").toLowerCase();

  const isRapor = path.includes("hazirbeton-rapor");
  const isDuzelt = path.includes("sevkiyat-duzelt");

  // ✅ Senin kuralların:
  // duzeltme=true -> her şey
  if (hb.duzeltme === true) return children;

  // rapor sayfası -> rapor OR giris OR duzeltme
  if (isRapor && (hb.rapor === true || hb.giris === true)) return children;

  // düzeltme sayfası -> sadece duzeltme (yukarıda zaten döndü)
  if (isDuzelt) {
    return <div style={{ textAlign: "center", marginTop: 40 }}>Yetkisiz Erişim</div>;
  }

  // diğer sayfalar -> giris
  if (hb.giris === true) return children;

  return <div style={{ textAlign: "center", marginTop: 40 }}>Yetkisiz Erişim</div>;
};

export default PrivateRoute;
